"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.sync.model.button': '同步模型',
    'chat.sync.model.tooltip': '同步到对话模型',
};
